import { useEffect , useState} from 'react'
import React from 'react'
import axios from 'axios'



import 'aos/dist/aos.css'; 

import splash from '../Assets/scoreboardsplash.jpg'
import splash_mobile from '../Assets/scoreboardsplash_mobile.jpg'
import ScoreBoardCompetition from './ScoreBoardCompetition';
import ScoreBoardTemplate from './ScoreBoardList/ScoreBoardTemplate';
import ScoreBoardList from '../ScoreBoardList';
import ScoreBoardDetails from './ScoreBoardDetails';
import './Selector.css'
import Navbar from './Navbar';
import Footer from './Footer';
import Top from './Top';
import AdminScore from './ScoreBoardList/AdminScore';

export default function ScoreBoard() {
  //class definitions
  const scoreboard_bg_image_class = "bg-cover bg-center";
  const scoreboard_competition_days_class = "flex-none w-[50px] h-[50px] lg:w-[135px] lg:h-[135px] bg-[#E09D42] border-black border-solid border-2"

  let [mainPage, setMainPage] = useState(true);
  let [currentCompe, setCurrentCompe] = useState("");
  let [currentJenjang, setCurrentJenjang] = useState("");
  let [currentGroup, setCurrentGroup] = useState("");
  let [currentDayIndex, setCurrentDayIndex] = useState(0);
  

  let [showModal, setShowModal] = useState(false);
  let [school1, setSchool1] = useState("");
  let [school2, setSchool2] = useState("");
  let [matchDetails, setDetails] = useState([]);
  let [compeName, setCompeName] = useState("");
  let [filtered, setFiltered] = useState([]);
  let [filteredByDay, setFilteredByDay] = useState([]);

  let [scores, setScore] = useState([]);
 
  useEffect(() => {
    getScores();
  }, []);
 
  const getScores = async () => {
    const response = await axios.get("https://livesoc.smakone.org/Scores");
    setScore(response.data);
  };

  function capitalizeFirstLetter(string) {
    if (!string) return string; // Check if the string is empty or undefined
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  
  let AOS;
  useEffect(() => {
    /**
     * Server-side rendering does not provide the 'document' object
     * therefore this import is required either in useEffect or componentDidMount as they
     * are exclusively executed on a client
     */

    const AOS = require("aos");
    AOS.init({
      once: true,
    });
  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  useEffect(() => {
    setFiltered(scores.filter(match => match.compe.includes(compeName)))
    if (filtered.length > 0) {
      setMainPage(false);
    }
  }, [compeName, mainPage])

  const toggleModal = (show, school1, school2, details) => {
    setShowModal(show);
    setSchool1(school1);
    setSchool2(school2);
    setDetails(details);
  }

  const onButtonClicked = (compe, jenjang, group) => {
    setCurrentCompe(compe);
    setCurrentJenjang(jenjang);
    setCurrentGroup(group);
    setCompeName(compe + jenjang + group); 
    setMainPage(false);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    console.log('a');
  }



  const onBack = () => {
    setMainPage(true)
    setCompeName("")
    setFiltered([])
    setFilteredByDay(filtered)
    document.location.reload()
  }

  const handleOptionChange = (event) => {
    // setEventTriggered(event.target.value)
    // console.log(eventTriggered)
    var intEvent = parseInt(event.target.value)
    if (intEvent == 0) {
      setFilteredByDay(filtered)
    } else {
      setFilteredByDay(filtered.filter(match => match.day == intEvent))
    }
  };

  return (
    <div className='overflow-y-hidden relative overflow-x-hidden'>
      {/* DETAILS MODAL */}
      {showModal && <ScoreBoardDetails compe={currentCompe} school1={school1} school2={school2} details={matchDetails} showModalFunc={setShowModal}/>}


      
      <div className='z-[50px]'>
        <div className='justify-center relative'
        // data-aos="zoom-in-up"
        // data-aos-offset="100"
        // data-aos-duration="1000"
        // data-aos-delay="0"
        // alt=""
        >
          
          <div className='z-3 w-full relative'>
                {/* <p className='flex justify-center items-center font-[BebasNeue] font-bold lg:text-[150px] text-[50px] mt-8 text-white'>SCOREBOARD</p> */}
            { mainPage ?
            (<div>
              <img src={splash} className='w-full' srcSet={`${splash_mobile} 768w, ${splash} 1200w`}></img>
              <div className='mt-8 mb-8 grid sm:grid-cols-1 md:grid-cols-2 gap-12 justify-items-center'>
                
                <ScoreBoardCompetition name='basket'
                func1={() => onButtonClicked("basket", "sma", "putra")}
                func2={() => onButtonClicked("basket", "sma", "putri")}
                func3={() => onButtonClicked("basket", "smp", "putra")}
                func4={() => onButtonClicked("basket", "smp", "putri")}
                text1='Putra SMA'
                text2='Putri SMA'
                text3='Putra SMP'
                text4='Putri SMP'
                bg='url(/src/Assets/CompesBackgrounds/basketwarna.png)'
                ></ScoreBoardCompetition>

                <ScoreBoardCompetition name='futsal'
                func1={() => onButtonClicked("futsal", "sma", "putra")}
                func2={() => onButtonClicked("futsal", "sma", "putri")}
                func3={() => onButtonClicked("futsal", "smp", "putra")}
                func4={() => onButtonClicked("futsal", "smp", "putri")}
                text1='Putra SMA'
                text2='Putri SMA'
                text3='Putra SMP'
                text4='Putri SMP'
                bg='url(/src/Assets/CompesBackgrounds/futsalwarna.png)'
                ></ScoreBoardCompetition>

                <ScoreBoardCompetition name='voli'
                func1={() => onButtonClicked("voli", "sma", "putra")}
                func2={() => onButtonClicked("voli", "sma", "putri")}
                func3={() => onButtonClicked("voli", "smp", "putra")}
                func4={() => onButtonClicked("voli", "smp", "putri")}
                text1='Putra SMA'
                text2='Putri SMA'
                text3='Putra SMP'
                text4='Putri SMP'
                bg='url(/src/Assets/CompesBackgrounds/voliwarna.png)'
                ></ScoreBoardCompetition>

                <ScoreBoardCompetition name='badminton'
                func1={() => onButtonClicked("badminton", "sma", "gandaputra")}
                func2={() => onButtonClicked("badminton", "sma", "gandaputri")}
                func3={() => onButtonClicked("badminton", "sma", "campur")}
                func4={() => onButtonClicked("badminton", "sma", "beregu")}
                func5={() => onButtonClicked("badminton", "smp", "gandaputra")}
                func6={() => onButtonClicked("badminton", "smp", "gandaputri")}
                text1='Ganda Putra SMA'
                text2='Ganda Putri SMA'
                text3='Campuran SMA'
                text4='Beregu SMP'
                text5='Ganda Putra SMP'
                text6='Ganda Putri SMP'
                bg='url(/src/Assets/CompesBackgrounds/badminwarna.png)'
                ></ScoreBoardCompetition>
            </div>
            </div>) : (<div className='mx-0 lg:mx-16'>
              {/* BACK BUTTON */}
              <button className='absolute left-1 top-1 lg:left-16 h-6 lg:h-16 w-12 lg:w-28 border-solid border-2 border-black bg-[#E09D42]' onClick={() => onBack()}>
                <span className='flex justify-center items-center text-xs lg:text-2xl text-black font-clashdisplay'>BACK</span>
              </button>
              
              

              {/* DAYS */}              
              <h1 className='text-center text-[#1F211E] font-britneybold text-4xl lg:text-7xl'>Scoreboard:<br></br>Match {capitalizeFirstLetter(currentCompe)} {capitalizeFirstLetter(currentGroup)}</h1>
              <div className='flex flex-row flex-nowrap overflow-x-auto my-4 w-full gap-2' style={{scrollbarColor: "#000000 #fff2cc"}}>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"2"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>23</p></button>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"3"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>24</p></button>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"4"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>25</p></button>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"5"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>26</p></button>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"6"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>27</p></button>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"7"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>28</p></button>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"8"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>29</p></button>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"9"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>30</p></button>
                <button className={scoreboard_competition_days_class}  onClick={() => handleOptionChange({target:{value:"10"}})} ><p className='font-clashdisplay text-[8px] lg:text-xl'>October</p><p className='font-clashdisplaybold text-2xl lg:text-7xl'>31</p></button>
              </div>
              
              {/* DAY CONTENT */}

              {/* TITLE */}
              <div className={(() => {switch(currentCompe){
                case 'basket':
                  return `${scoreboard_bg_image_class} bg-[url(/src/Assets/basket_scoreboard.png)]`;
                case 'futsal':
                  return `${scoreboard_bg_image_class} bg-[url(/src/Assets/futsal_scoreboard.png)]`;
                case 'voli':
                  return `${scoreboard_bg_image_class} bg-[url(/src/Assets/voli_scoreboard.png)]`;
                case 'badminton':
                  return `${scoreboard_bg_image_class} bg-[url(/src/Assets/badmin_scoreboard.png)]`;
                default:
                  return "p-4 bg-red-500";
              }})()}>
                {filteredByDay.length > 0 ? filteredByDay.map((match, index) => <ScoreBoardTemplate match={match} toggleModal={toggleModal}/>) : null }
              </div>
              
            </div>)
            }
          </div>
        </div>
      </div>
    </div>
  )
}
